<template>
  <iq-card>
    <template #headerTitle>
      <h5 class="text-primary mb-0"><strong>Job Library</strong></h5>
    </template>
    <template #body>
      <CustomNav :items="tabs" @item-click="(tab) => (activeTab = tab)" class="mb-4" />
      <template v-if="activeTab == 'per-category'">
        <CategoryJobLibraryList />
      </template>
      <template v-else>
        <JobLibraries />
      </template>
    </template>
  </iq-card>
</template>

<script>
import CustomNav from '@/src/components/global/CustomNav.vue'
import CategoryJobLibraryList from './CategoryJobLibraryList.vue'
import JobLibraries from './JobLibraries.vue'

export default {
  components: {
    CustomNav,
    CategoryJobLibraryList,
    JobLibraries,
  },
  data() {
    return {
      activeTab: 'per-category',
      tabs: [
        {
          value: 'per-category',
          label: 'Job Library By Category',
        },
        {
          value: 'all',
          label: 'All Job Library',
        },
      ],
    }
  },
}
</script>
